import * as React from "react"
import { Check } from "lucide-react"

import { cn } from "@/lib/utils"

export interface CheckboxProps
  extends Omit<React.InputHTMLAttributes<HTMLInputElement>, "type"> {
  containerClassName?: string
}

/**
 * Accessible checkbox backed by a native input (no extra dependency).
 * The native input is visually hidden and drives a styled box via peer styles.
 */
const Checkbox = React.forwardRef<HTMLInputElement, CheckboxProps>(
  ({ className, containerClassName, checked, disabled, ...props }, ref) => (
    <label
      className={cn(
        "relative inline-flex h-4 w-4 shrink-0 items-center justify-center",
        disabled ? "cursor-not-allowed opacity-50" : "cursor-pointer",
        containerClassName
      )}
    >
      <input
        type="checkbox"
        ref={ref}
        checked={checked}
        disabled={disabled}
        className="peer absolute inset-0 h-full w-full cursor-[inherit] appearance-none rounded-sm border border-primary shadow focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 checked:border-primary checked:bg-primary"
        {...props}
      />
      <Check
        className={cn(
          "pointer-events-none h-3 w-3 text-primary-foreground opacity-0 peer-checked:opacity-100",
          className
        )}
      />
    </label>
  )
)
Checkbox.displayName = "Checkbox"

export { Checkbox }
